angular.module('sharecrf.progress-status', [ 'ecrd' ]);
